import isEmail from 'validator/es/lib/isEmail'

/**
 * 定義畫面的檢視模式變數
 */
export function useViewMode() {
  const { locale } = useI18n()
  const member = useMember()
  const isOldNominee = computed(() => member.value && member.value.nominee && !isEmail(member.value.id) )
  return {
    /**
     * 目前頁面是否為英文版
     */
    english: computed(() => locale.value === 'en'),
    /**
     * 目前會員是否為 Agent
     */
    agent: computed(() => member.value && member.value.group === MemberGroup.Agent),
    /**
     * 目前會員是否為 Agent 或是 Admin
     */
    agentOrAdmin: computed(() => member.value && [MemberGroup.Agent, MemberGroup.Admin].includes(member.value.group)),
    /**
     * 目前會員是否為 holder
     */
    holder: computed(() => member.value && member.value.group === 'holder'),
    /**
     * 目前會員是否為 nominee
     */
    nominee: computed(() => member.value && member.value.nominee),
    /**
     * 目前會員是否為 admin
     */
    admin: computed(() => member.value && member.value.group === 'admin'),
    /**
     * Migration: 舊版 Nominee 帳號 (非 email 作為帳號)
     * Nominee 唯一的帳號，沒有交易權限，但可以執行任何 Nominee 功能
     */
    isOldNominee,
    /** 
     * 是否為可以 Keyin 唯一交易的 nominee Agent (無其他 sub-sale)
     * 例外：如果是舊版的 Nominee (非 email 作為帳號) 也視為 不需檢查是否有交易權限
     */
    nomineeDealer: computed(() => isOldNominee.value || (member.value && member.value && member.value.nominee && member.value.asAgent && usePrivilege(Privilege.TradeKeyin))),
    /** 
     * 交易輸入者：是否為TradeKeyin檢視狀態
     */
    tradeClerk: computed(() => usePrivilege(Privilege.TradeKeyin)),
    /** 
     * 交易審查者：是否為TradeApprove檢視狀態
     */
    tradeApprover: computed(() => usePrivilege(Privilege.TradeApprove)),
  }
}

/**
 * <html lang="">
 */
export function useHtmlLang() {
  const { locale } = useI18n()
  const lang = ref('')
  watchEffect(() => {
    if (locale.value === 'zh') {
      lang.value = 'zh-TW'
    }
    if (locale.value === 'en') {
      lang.value = 'en-US'
    }
  })
  return lang
}